<template>
  <div id="agMaxConn">
    <div class="agInputGroup agInputGroupCentered">
      <label>Auth Type:</label>
      <b-form-select
        v-model="connection.authType"
        :disabled="isReadonly"
        :options="authTypes"
        style="width:200px;">
      </b-form-select>
    </div>
    <div id="agMaxConn-multiSelect" class="agInputGroup">
      <label>Object Structures:</label>
      <multiselect 
          v-model="connection.datasets"
          :loading="isLoading"
          :options="osOptions" 
          :multiple="true" 
          label="name"
          track-by="os"
          :close-on-select="false" 
          :clear-on-select="false" 
          :show-no-results="false" 
          placeholder="Select Object Structures"
          @search-change="setOptions"
          @open="setOptions" >
          <span slot="noResult">No Object Structures found</span>
        </multiselect>
    </div>
  </div>
</template>


<script>

// components

// modules
import Server from './../../server'


export default {
  name: "ag-max-conn",
  components: {
    
  },
  props: {
    isReadonly: Boolean,
    connection: Object,
  },

  data() {
    return {
        isLoading: false,
        authTypes: [
            { value: "maxauth", text: "MAXAUTH" },
            { value: "basic", text: "Basic" },
            { value: "form", text: "Form" },
            { value: "apikey", text: "API Key" }
        ],
        osOptions: [],
        allOS: []
    };
  },

  computed: {

  },

  mounted() {
    this.setOptions();
  },

  methods: {

    setOptions(query) {
      this.osOptions = []
      this.isLoading = true;
      if (this.allOS.length == 0){
        let body = {connection: this.connection, osString: query};
        Server.post("getMaxObjectStructures", body).promise.then((osList) => {
          if(osList.data.success && osList.data.os){
            this.allOS = osList.data.os;
            this.osOptions = [...this.allOS];
          }
          this.isLoading = false;
        });
      }else{
        if (typeof query != "undefined" && query != ""){
          this.osOptions = this.allOS.filter(a => a.os.includes(query))
        }
        else {
          this.osOptions = [...this.allOS];
        }
        this.isLoading = false;
      }
    },

    clearAll() {
      this.connection.datasets = []
    },

    // UI Events

    // other

    reset() {
      
    },

    prepareForSave() {
    },

  }
};
</script>

<style scoped lange="css">
  .agObjectStructure-fieldSearch {
    width: 200px;
  }


</style>


// WEBPACK FOOTER //
// src/components/connection/MaxConnection.vue